import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "../../config/baseUrl";
import { Link } from "react-router-dom";
import JobScheduleEdit from "./jobschedule-edit";
import JobScheduleAdd from "./jobschedule-add";
import EduPagination from "../edu-pagination/edu-pagination";
import { JobScheduleCard } from "./jobschedule-card";

export default function JobScheduleListTable() {
  const [jobScheduleduleData, setJobScheduleData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageLimit, setPageLimit] = useState(9);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize, setPageSize] = useState(12);
  const [activateJobScheduleAdd, setActivateJobScheduleAdd] = useState(false);
  const [activateJobScheduleEdit, setActivateJobScheduleEdit] = useState(false);
  const [selectJobScheduleRow, setSelectJobScheduleRow] = useState([]);
  const [forceUpdate, setForceUpdate] = useState(false);
  const [campusList, setCampusList] = useState([]);
  const [selectedCampus, setSelectedCampus] = useState("");
  const [assignDate, setAssignDate] = useState("");
  const [cleaningType, setCleaningType] = useState("");
  const [cleaningState, setCleaningState] = useState("");
  const [collegeId, setCollegeId] = useState("");

  // Get login user for CSV download
  let loginUser = {};
  try {
    loginUser = JSON.parse(localStorage.getItem("user"));
  } catch (error) {
    console.error("Error parsing user data from localStorage:", error);
  }

  let JobScheduleList = async () => {
    try {
      let reportDone = "";
      if (cleaningState === "1") {
        reportDone = "true";
      } else if (cleaningState === "2") {
        reportDone = "false";
      }

      const url = `${baseUrl}/get_scheduler/?page=${pageNumber}&college__campus=${selectedCampus}&college=${collegeId}&assign_date=${assignDate}&cleaning_type=${cleaningType}&report_done=${reportDone}`;

      let response = await axios(url, {
        method: "GET",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
      });
      if (response?.status === 200 || response?.data?.code === 200) {
        // Handle different possible response structures
        const extra = response?.data?.extra || {};
        const totalCountValue = extra.count || response?.data?.count || 0;
        const totalPagesValue = extra.total || 1;
        const pageSizeValue = extra.page_size || 12;
        const dataArray = response?.data?.data || [];

        setTotalCount(totalCountValue);
        setTotalPages(totalPagesValue);
        setPageSize(pageSizeValue);
        setJobScheduleData(dataArray);

      }
    } catch (error) {
      console.error("Error fetching job schedule:", error);
      console.error("Error response:", error?.response?.data);
      // Set defaults on error to prevent UI issues
      setTotalCount(0);
      setTotalPages(1);
      setJobScheduleData([]);
    }
  };

  let CampusList = async () => {
    try {
      let response = await axios(`${baseUrl}/get_campus/`, {
        method: "GET",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
      });
      if (response?.status === 200) {
        setCampusList(response?.data?.data || []);
      }
    } catch (error) {
      setCampusList([]);
    }
  };

  let filterByCampusHandler = async (e) => {
    setSelectedCampus(e.target.value);
  };

  let onFilterSubmit = async (e) => {
    e.preventDefault();
    setPageNumber(1); // Reset to page 1 when filtering
    setForceUpdate(!forceUpdate);
  };

  useEffect(() => {
    (async function () {
      try {
        await JobScheduleList();
      } catch (error) {
        console.error("Error :", error.response?.data);
      }
    })();
  }, [
    forceUpdate,
    pageNumber,
    selectedCampus,
    collegeId,
    assignDate,
    cleaningType,
    cleaningState,
  ]);

  useEffect(() => {
    try {
      (async function () {
        if (campusList?.length === 0) {
          await CampusList();
        }
      })();
    } catch (error) {
      console.error("Error :", error.response.data);
    }
  }, [forceUpdate]);

  return (
    <>
      {/* <Header /> */}
      {/* <Sidebar activeItem={"BusManagement"} /> */}
      <section className="main-sec">
        <div className="row">
          <div className="col-lg-12">
            <div className="dashboard-title">
              <h4 className="dash-head">
                <i className="fa fa-chart-bar me-2" />
                JobSchedule List
              </h4>
              <div className="d-flex gap-2 align-items-center">
                <Link
                  to="campus"
                  className="blu-btn"
                  onClick={() => setActivateJobScheduleAdd(true)}
                >
                  <i className="fa  fa-calendar me-2" />
                  Change Schedule
                </Link>
                <Link
                  role="button"
                  className="blu-btn"
                  data-bs-toggle="modal"
                  data-bs-target="#addjobScheduledule"
                  onClick={() => setActivateJobScheduleAdd(true)}
                >
                  <i className="fa fa-plus me-2" />
                  Add New Job
                </Link>
              </div>
            </div>
            <div className="custom-bredcump">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/education">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    JobSchedule List
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="cards bus-list">
              {loginUser?.id && (
                <div className="mb-3 d-flex justify-content-start">
                  <Link
                    className="btn btn-primary mb-2 ms-1"
                    to={`${baseUrl}/download_college_scheduler_excel/${loginUser?.id}`}
                  >
                    <i className="fa fa-download me-2"></i>Download CSV
                  </Link>
                </div>
              )}
              <div className="bus-filter">
                <div className="row justify-content-end gap-2">
                  <div className="col-lg-2">
                    <select
                      name="campus"
                      onChange={filterByCampusHandler}
                      className="form-select"
                      value={selectedCampus}
                    >
                      <option value="">
                        {selectedCampus === ""
                          ? "Select College"
                          : "Clear Select"}
                      </option>
                      {campusList?.map((arr) => {
                        return (
                          <option key={arr?.id} value={arr?.id}>
                            {arr?.campus_name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-lg-2">
                    <select
                      name="campus"
                      onChange={(e) => setCleaningType(e.target.value)}
                      className="form-select"
                      value={cleaningType}
                    >
                      <option value="">
                        {cleaningType === ""
                          ? "Select Cleaning Type"
                          : "Clear Select"}
                      </option>
                      <option value="REGULAR_CLEANING">
                        Regular Cleaning{" "}
                      </option>
                      <option value="TERM_CLEANING">Term Cleaning</option>
                    </select>
                  </div>
                  <div className="col-lg-2">
                    <select
                      name="state"
                      onChange={(e) => setCleaningState(e.target.value)}
                      className="form-select"
                      value={cleaningState}
                    >
                      <option value="">
                        {cleaningState === "" ? "Select State" : "Clear Select"}
                      </option>
                      <option value="1">Complete</option>
                      <option value="2">Pending</option>
                    </select>
                  </div>
                  <div className="col-lg-2">
                    <input
                      type="date"
                      className="form-control"
                      placeholder="Start Date"
                      value={assignDate}
                      onChange={(e) => {
                        setAssignDate(e.target.value);
                      }}
                    />
                  </div>
                  <div className="col-lg-2">
                    <button className="thm-btn w-100" onClick={onFilterSubmit}>
                      Submit
                    </button>
                  </div>
                </div>
              </div>
              <div className="d-flex flex-wrap justify-content-center align-items-center mb-3 gap-4">
                <>
                  {jobScheduleduleData?.length > 0 ? (
                    <>
                      {jobScheduleduleData?.map((arr) => (
                        <JobScheduleCard
                          key={arr?.id}
                          report_done={arr?.report_done}
                          id={arr?.id}
                          cleaning_type={arr?.cleaning_type}
                          assign_date={arr?.assign_date}
                          college={arr?.college}
                          company={arr?.company}
                          campus={campusList}
                          setActivateJobScheduleEdit={
                            setActivateJobScheduleEdit
                          }
                          setSelectJobScheduleRow={setSelectJobScheduleRow}
                          forceUpdate={forceUpdate}
                          setForceUpdate={setForceUpdate}
                        />
                      ))}
                    </>
                  ) : (
                    <></>
                  )}
                </>
              </div>
              <EduPagination
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
                pageLimit={totalPages}
                setPageLimit={setPageLimit}
                totalCount={totalCount}
                isTotalPages={true}
                pageSize={pageSize} // Add this prop
              />
            </div>
          </div>
        </div>
      </section>

      <JobScheduleEdit
        selectJobScheduleRow={selectJobScheduleRow}
        setForceUpdate={setForceUpdate}
        forceUpdate={forceUpdate}
        activateJobScheduleEdit={activateJobScheduleEdit}
        setActivateJobScheduleEdit={setActivateJobScheduleEdit}
      />

      <JobScheduleAdd
        setForceUpdate={setForceUpdate}
        forceUpdate={forceUpdate}
        activateJobScheduleAdd={activateJobScheduleAdd}
        setActivateJobScheduleAdd={setActivateJobScheduleAdd}
      />
    </>
  );
}
